import { DRINKS, IMAGES } from "@/lib/menuData";
import { Sparkles } from "lucide-react";

export const Drinks = () => {
  return (
    <section id="drinks" data-testid="drinks-section" className="border-b-2 border-[color:var(--brand-ink)] bg-[color:var(--brand-bg-2)]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="grid lg:grid-cols-12 gap-8 items-stretch">
          <div className="lg:col-span-5 relative">
            <div className="border-2 border-[color:var(--brand-ink)] shadow-brutal overflow-hidden h-full min-h-[360px]">
              <img
                src={IMAGES.horchata}
                alt="Refreshing horchata, our signature drink"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="absolute -top-3 -left-3 bg-[color:var(--brand-red)] text-white font-display text-xl uppercase px-3 py-1 border-2 border-[color:var(--brand-ink)] shadow-brutal-sm stamp">
              Signature
            </span>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            <p className="font-bold text-sm uppercase tracking-[0.2em] text-[color:var(--brand-red)]">Drinks</p>
            <h2 className="font-display text-5xl sm:text-6xl uppercase mt-2">
              Cold. Sweet. <span className="text-[color:var(--brand-red)]">Horchata</span>.
            </h2>
            <p className="mt-4 text-[color:var(--brand-ink-2)] max-w-xl">
              Our house horchata is the main event — creamy rice milk, cinnamon, and a hit of vanilla. Pair it with anything on the menu.
            </p>

            <div data-testid="horchata-highlight" className="mt-6 inline-flex self-start items-center gap-2 bg-[color:var(--brand-yellow)] border-2 border-[color:var(--brand-ink)] font-bold uppercase px-3 py-1.5 shadow-brutal-sm text-sm">
              <Sparkles size={14} strokeWidth={2.75} /> {DRINKS.highlight.tagline}
            </div>

            <h3 className="mt-10 font-display text-2xl uppercase">Also on Ice</h3>
            <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-2">
              {DRINKS.others.map((d) => (
                <li
                  key={d}
                  className="border-2 border-[color:var(--brand-ink)] bg-white px-4 py-3 font-medium flex items-center justify-between shadow-brutal-sm"
                >
                  <span>{d}</span>
                  <span className="inline-block w-2 h-2 bg-[color:var(--brand-red)]" />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Drinks;
